import React from 'react';
import { Row, Col, Form, Card, Alert, Button } from 'react-bootstrap';
import SearchableSelect from '../common/SearchableSelect';

const ReconcileSetup = ({ 
  selectedAccount, 
  setSelectedAccount, 
  accounts, 
  onFileUpload, 
  reconcileData, 
  setReconcileData, 
  recentDocuments, 
  savedStatements,
  loadExistingDocument, 
  fetchDbTransactions, 
  loading, 
  error 
}) => {
  return (
    <Card className="shadow-sm border-0">
      <Card.Body className="p-4">
        <h5 className="mb-4 text-muted small text-uppercase font-weight-bold">Start Reconciliation</h5>
        {error && <Alert variant="warning" className="small border-0 shadow-sm"><i className="fas fa-exclamation-triangle mr-2"></i>{error}</Alert>}
        
        <Row>
          {/* Main Manual Entry Section */}
          <Col md={7}>
            <div className="bg-white p-4 border rounded shadow-sm">
                <Form.Group className="mb-4">
                    <Form.Label className="font-weight-bold">1. Select Account</Form.Label>
                    <SearchableSelect
                        options={accounts && accounts.length > 0 ? (
                            accounts.map(acc => ({ value: acc._id, label: acc.name, sublabel: `$${acc.balance?.toFixed(2)}` }))
                        ) : []}
                        value={selectedAccount} 
                        onChange={e => setSelectedAccount(e.target.value)}
                        placeholder="-- Select Bank Account --"
                    />
                </Form.Group>

                <h6 className="font-weight-bold mb-3">2. Enter Statement Details</h6>
                <Row>
                    <Col md={12}>
                        <Form.Group className="mb-3">
                            <Form.Label className="small text-muted">Statement Ending Date</Form.Label>
                            <Form.Control 
                                type="date"
                                value={reconcileData.statementDate}
                                onChange={e => setReconcileData({...reconcileData, statementDate: e.target.value})}
                                required
                            />
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label className="small text-muted">Beginning Balance</Form.Label>
                            <Form.Control 
                                type="number" step="0.01" 
                                value={reconcileData.beginningBalance}
                                onChange={e => setReconcileData({...reconcileData, beginningBalance: parseFloat(e.target.value) || 0})}
                            />
                            <Form.Text className="text-muted" style={{fontSize: '0.7rem'}}> Pulled from last reconciled balance.</Form.Text>
                        </Form.Group>
                    </Col>
                    <Col md={6}>
                        <Form.Group className="mb-3">
                            <Form.Label className="small text-muted font-weight-bold">Ending Balance</Form.Label>
                            <Form.Control 
                                type="number" step="0.01" className="border-primary"
                                value={reconcileData.endingBalance}
                                onChange={e => setReconcileData({...reconcileData, endingBalance: parseFloat(e.target.value) || 0})}
                                placeholder="0.00"
                                required
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Button variant="primary" block className="mt-4 py-2 font-weight-bold shadow-sm" onClick={fetchDbTransactions} disabled={loading}>
                    {loading ? 'Preparing...' : 'Start Reconciling'}
                </Button>
            </div>
          </Col>

          {/* Helper Column */}
          <Col md={5}>
            <div className="pl-md-4">
                <div className="alert alert-light border small mb-4">
                    <i className="fas fa-lightbulb text-warning mr-2"></i>
                    <strong>Tip:</strong> You don't need to upload a file to reconcile. Just type the numbers from your bank statement and click "Start".
                </div>

                <div className="p-4 border-dashed rounded text-center bg-light mb-4" style={{ border: '2px dashed #dee2e6' }}>
                    <i className="fas fa-magic text-primary opacity-50 mb-2"></i>
                    <p className="small font-weight-bold mb-1">Need help typing?</p>
                    <p className="text-muted extra-small mb-3">Upload a PDF to auto-fill these boxes</p>
                    <div className="custom-file custom-file-sm">
                        <input 
                            type="file" 
                            className="custom-file-input" 
                            id="pdf-upload" 
                            onChange={onFileUpload} 
                            accept=".pdf" 
                        />
                        <label className="custom-file-label small" htmlFor="pdf-upload">Choose PDF</label>
                    </div>
                </div>

                {savedStatements && savedStatements.length > 0 && (
                <div className="mt-2">
                    <h6 className="extra-small font-weight-bold text-muted text-uppercase mb-2">Or Use Previous Imports</h6>
                    <div className="list-group list-group-flush border rounded overflow-hidden">
                        {savedStatements.slice(0, 3).map(s => (
                            <button 
                                key={s._id}
                                className="list-group-item list-group-item-action py-2 px-3 extra-small d-flex justify-content-between align-items-center"
                                onClick={() => loadExistingDocument(s._id)}
                            >
                                <span className="text-truncate">
                                    <i className="fas fa-history mr-2 text-muted"></i>
                                    {s.periodEnd ? new Date(s.periodEnd).toLocaleDateString(undefined, { month: 'short', year: 'numeric' }) : s.originalName}
                                </span>
                                <i className="fas fa-chevron-right text-muted" style={{fontSize: '0.6rem'}}></i>
                            </button>
                        ))}
                    </div>
                </div>
                )}
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ReconcileSetup;
